import { createContext, PropsWithChildren, useContext } from 'react';
import { usePosthogProviderController } from './controller';
import { PosthogContextType, PosthogProviderViewProps } from './types';

export const PosthogContext = createContext<PosthogContextType>({
  sendEvent: () => {},
});

export function usePosthogContext() {
  const context = useContext(PosthogContext);

  return context;
}

export function PosthogProvider({
  children,
  posthog_distinct_id,
}: PropsWithChildren<PosthogProviderViewProps>) {
  const value = usePosthogProviderController(posthog_distinct_id);
  return (
    <PosthogContext.Provider value={value}>{children}</PosthogContext.Provider>
  );
}
